/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * Locale for the SMS message
 */
export enum SendOtpBodyLocale {
  en = 'en',
  fr = 'fr'
}
